/**
 * Client-storage key classification.
 *
 * Active per-user data is stored via UserScopedStorageService (keys become
 * `<name>::<email>`), so it is isolated between accounts on a shared browser and
 * survives a logout/login for the same account — no logout wipe needed.
 *
 * This list is the one-time legacy purge set: the pre-namespacing bare (global)
 * versions of every name below are removed once at startup. It therefore also
 * includes keys that no longer live in per-user localStorage at all —
 * `search` (moved to a per-tab sessionStorage handoff) and `bookmarking_tool_popup`
 * (a removed feature) — purely so their stale global values get cleaned up.
 *
 * Auth-scoped keys (`token`, `tokenDataAccess`, `impersonate`) are owned by
 * TokenService and are deliberately not listed here.
 */
export const USER_SCOPED_KEYS = [
  'search',
  'news_curation',
  'pinReportTab',
  'company_filter',
  'mosaics_filter',
  'score_company_filter',
  'score_mosaics_filter',
  'dd_recent_searches_v2',
  'dd_recent_searches',
  'ai_banner_last_shown',
  'ai_search_recents_v1',
  'bookmarking_tool_popup',
] as const;

/** A property of the device, not the user — global, never namespaced or purged. */
export const DEVICE_SCOPED_KEYS = ['theme', 'aside', 'chartVisible'] as const;
